import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { LazyImgLoadingDirective } from '../../../directives/lazy-img-loading.directive';
import { AvatarModule } from '../../avatar/avatar.module';
import { AudioRecordingService } from './audio-recording.service';
import { AttachmentButtonComponent } from './components/attachment-button/attachment-button.component';
import { AudioPreviewCellComponent } from './components/audio-preview-cell/audio-preview-cell.component';
import { HistorySeparatorComponent } from './components/history-separator/history-separator.component';
import { ImagePreviewCellComponent } from './components/image-preview-cell/image-preview-cell.component';
import { MessageContentCellComponent } from './components/message-content-cell/message-content-cell.component';
import { ConversationComponent } from './conversation.component';

@NgModule({
  declarations: [
    ConversationComponent,
    AttachmentButtonComponent,
    MessageContentCellComponent,
    HistorySeparatorComponent,
    AudioPreviewCellComponent,
    ImagePreviewCellComponent,
  ],
  exports: [ConversationComponent],
  imports: [
    CommonModule,
    AvatarModule,
    AutosizeModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    FormsModule,
    TooltipModule,
    BsDropdownModule,
  ],
  providers: [AudioRecordingService, LazyImgLoadingDirective],
})
export class ConversationModule {}
